var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgErrorSign(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 189,
    height: 189,
    viewBox: "0 0 189 189",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4374",
    "data-name": "Group 4374",
    transform: "translate(-837 -185)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2733",
    "data-name": "Ellipse 2733",
    cx: 94.5,
    cy: 94.5,
    r: 94.5,
    transform: "translate(837 185)",
    fill: "#eaf3fa",
    opacity: 0.56
  }), /*#__PURE__*/React.createElement("path", {
    id: "_9035016_warning_icon",
    "data-name": "9035016_warning_icon",
    d: "M159.252,158.184,111.991,70.417a8.873,8.873,0,0,0-15.626,0L49.106,158.184a8.874,8.874,0,0,0,7.8,13.081h94.531a8.874,8.874,0,0,0,7.814-13.081Zm-55.073-.507a5.546,5.546,0,1,1,5.546-5.546,5.546,5.546,0,0,1-5.546,5.546ZM110.2,101.9l-1.592,33.831a4.437,4.437,0,1,1-8.874,0l-1.592-33.817h0a6.026,6.026,0,0,1,5.962-6.292h.058a6.029,6.029,0,0,1,6.026,6.295Z",
    transform: "translate(827.624 150.716)",
    fill: "#bbcdff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorSign);
export default __webpack_public_path__ + "static/media/ErrorSign.8ce293ae3f07e5a1e9e471c16ee83cfd.svg";
export { ForwardRef as ReactComponent };